import React from 'react'
import styled from 'styled-components'

// Elements
import ParseContent from 'components/shared/ParseContent'
import Title from 'components/elements/Title'

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    font-size: 24px;
  }

  & p {
    @media (min-width: 992px) {
      font-size: 18px;
      line-height: 30px;
    }
  }
`

interface TextDefaultProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
}

function TextDefault({ fields }: TextDefaultProps) {
  return (
    <section>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            {fields?.title && <Title>{fields.title}</Title>}
            <Content content={fields.description} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default TextDefault
